import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";
import { Calculator } from "lucide-react";

const LABEL = {
  passing_yds: "PASS YDS",
  passing_tds: "PASS TDS",
  rushing_yds: "RUSH YDS",
  rushing_tds: "RUSH TDS",
  receptions: "CATCHES",
  rec_yds: "REC YDS",
  rec_tds: "REC TDS",
  sacks: "SACKS",
  loss_of_yds: "LOSS YDS",
  ints: "INT",
  def_tds: "DEF TDS",
};

export default function ScoringLegend({ position, compact = false }) {
  const [rules, setRules] = useState(null);
  useEffect(() => {
    api.get("/scoring/rules").then(({ data }) => setRules(data.rules)).catch(() => {});
  }, []);
  if (!rules || !rules[position]) return null;

  const entries = Object.entries(rules[position]);

  return (
    <div
      className="px-4 py-3 border-b border-white/10 flex items-center gap-3 flex-wrap"
      data-testid={`scoring-legend-${position}`}
      style={{ background: "rgba(0, 255, 102, 0.03)" }}
    >
      <div className="inline-flex items-center gap-1.5 text-[#00FF66] text-xs uppercase tracking-widest">
        <Calculator size={12} /> {position} Scoring
      </div>
      <div className="flex flex-wrap gap-x-3 gap-y-1">
        {entries.map(([stat, mult]) => (
          <span key={stat} className="text-xs">
            <span className="text-white/40">{LABEL[stat] || stat}</span>
            <span
              className="ml-1 font-display"
              style={{ color: mult < 0 ? "#FF3B30" : "#00FF66" }}
            >
              ×{mult}
            </span>
          </span>
        ))}
      </div>
    </div>
  );
}
